import React, { useState, useEffect } from 'react';
import { Fragment } from 'react';
import Axios from '../../config/axios';
import { toast, confirm } from '@rickylandino/react-messages';
import { Spin, Alert, Empty, Card, List } from 'antd';
import { useForm, Controller } from "react-hook-form";
import { useLocal } from '../Helpers/GetLocal';

export default function BulletinBoard() {
    const [state, setState] = useState({
        dataLoaded: false,
        bulletinBoardJobs: []
    });

    const local = useLocal();
    const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
    const { register, getValues, setValue, control } = useForm();

    const data = [
        {
            title: 'Title 1',
        },
        {
            title: 'Title 2',
        },
        {
            title: 'Title 3',
        },
        {
            title: 'Title 4',
        },
    ];

    useEffect(() => {
        LoadBulletingBoardJobs();
    }, []);

    function LoadBulletingBoardJobs() {
        Axios.get(`/api/GetBulletinBoardJobs`, {
            params: {

            }
        }).then(response => {
            console.log(response.data);

            setState({
                ...state,
                bulletinBoardJobs: response.data,
                dataLoaded: true
            });
        }).catch(error => {
            console.log(error);
        });
    }

    function formatCurrency(value) {
        return value.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
        });
    }

    return (
        <div>
            <div className="row">
                <div className="col-lg-12" >
                    <div className="panel-hdr">
                        <h2>
                            {`LOCAL ${local} Is Offering Market Recovery On The Following Jobs. Please submit a request if you plan to bid on any of them.`}
                        </h2>
                    </div>
                    <Fragment>
                        <br />
                        
                        {/*<hr style={{ border: "1px solid" }} />*/}

                        <div>
                            <Spin spinning={!state.dataLoaded}>
                                <div style={!state.dataLoaded ? {} : { display: 'none' }}>
                                    <Alert
                                        message="Loading Jobs"
                                        description="Please stand by while we retrieve all eligible jobs"
                                        type="info"
                                    />
                                </div>
                                {state.dataLoaded &&
                                    <Fragment>
                                        {state.bulletinBoardJobs.length === 0 ?
                                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={
                                                <span>
                                                    No Matching Jobs Found At This Time. Please Check Back Soon
                                                </span>
                                            } />
                                            :
                                            <>
                                                <List
                                                    grid={{ gutter: 16, column: 4 }}
                                                    dataSource={state.bulletinBoardJobs}
                                                    renderItem={item => (
                                                        <List.Item>
                                                            <Card title={item.jobName}><b>Job Details: </b>{item.jobDetails}<br /><b>Location: </b>{item.city}, {item.state}<br /><b>Market Recovery Funding Available:</b> {formatCurrency(item.dollarsPerHour)}/hr</Card>
                                                        </List.Item>
                                                    )}
                                                />
                                            </>
                                        }
                                    </Fragment>
                                }
                            </Spin>
                        </div>
                    </Fragment>
                </div>
            </div>
        </div>
    );
}